var generateStyle = function generateStyle(componentTheme) {
  return {
    content: {
      padding: "".concat(componentTheme.contentPaddingTopBottom, " ").concat(componentTheme.contentPaddingLeftRight),
      backgroundColor: componentTheme.contentBackgroundColor
    },
    breadcrumb: {
      marginBottom: "".concat(componentTheme.breadCrumbMarginBottom)
    },
    header: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      paddingBottom: "".concat(componentTheme.headerPaddingBottom)
    },
    borderedBottom: {
      borderBottom: "".concat(componentTheme.headerBorderWidth, " solid ").concat(componentTheme.headerBorderColor)
    },
    filters: {
      paddingBottom: '2rem'
    },
    filtersRow: {
      display: 'flex',
      flexDirection: 'row'
    }
  };
};
export default generateStyle;